export default function getProfile(a_oQuestions) {
  let oLettersAndScore = {
    E: 0,
    I: 0,
    N: 0,
    S: 0,
    T: 0,
    F: 0,
    J: 0,
    P: 0,
    none: 0
  };

  /**
    - Extravert -> E of Introvert -> I
    - Intuition -> N of Sensing -> S
    - Thinking -> T of Feeling -> F
    - Judging -> J of Percieving -> P
    */

  // console.error(a_oQuestions);
  a_oQuestions.forEach(oQuestion => {
    //category 1 -> keywords
    if (oQuestion.type === "keywords") {
      //map function doesn't work because the keys have a name
      Object.keys(oQuestion.givenAnswers).forEach(key => {
        let oAnswer = oQuestion.givenAnswers[key];

        if (oAnswer.checked === true) {
          oLettersAndScore[oAnswer.score]++;
        }
      });
    }

    //category 2 -> single-choice
    if (oQuestion.type === "single-choice") {
      oLettersAndScore[oQuestion.givenAnswers.score]++;
    }
  });

  return getStringScore(oLettersAndScore);
}

/**
 * Returns a four letter string
 * @param oScores
 * @returns {string}
 */
function getStringScore(oScores) {
  let sReturnString = "";
  sReturnString = sReturnString + getCorrectLetter(oScores, "E", "I");
  sReturnString = sReturnString + getCorrectLetter(oScores, "N", "S");
  sReturnString = sReturnString + getCorrectLetter(oScores, "T", "F");
  sReturnString = sReturnString + getCorrectLetter(oScores, "J", "P");

  return sReturnString;
}

/**
 * Returns the correct letter used in the four letter string
 * example return: E
 * @param oScores
 * @param sLetterOne
 * @param sLetterTwo
 * @returns {*}
 */
function getCorrectLetter(oScores, sLetterOne, sLetterTwo) {
  if (oScores[sLetterOne] > oScores[sLetterTwo]) {
    return sLetterOne;
  } else if (oScores[sLetterOne] === oScores[sLetterTwo]) {
    return sLetterOne;
  } else {
    return sLetterTwo;
  }
}



// WEBPACK FOOTER //
// ./src/utils/getProfile.js